// Isomorphic useLayoutEffect to prevent eslint warning
// https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
import { useLayoutEffect, useEffect } from 'react'

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

// Export as useLayoutEffect so that "react-hooks/exhaustive-deps" eslint rule will work
export { useIsomorphicLayoutEffect as useLayoutEffect }
